/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  pageHeading: {
    id: "b2b.zakaznici-grid.label",
    defaultMessage: "Customers"
  }
});

export default () => useMessages(MESSAGES);
